import getKhattabatSelectsStore from "../../../../../stores/khattabat-stores/selects-store";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import SelectAll from "../../shared/SelectAll";

const SelectAllContainer = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const selectedAllCount = getKhattabatSelectsStore().selectedCount.get();
  const isSelectedAll =
    getKhattabatSelectsStore().isSelectedAll("matchResultPage");

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={1510}
      height={70}
      color={""}
      style={{}}
      onClick={() => {}}
    >
      <SelectAll
        onClick={() =>
          getKhattabatSelectsStore().toggleAllMarksStates("matchResultPage")
        }
        state={isSelectedAll}
      />

      {!isSelectedAll ? null : (
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={25}
          isSpan={true}
          text={`${selectedAllCount}`}
          style={{ color: colors.all.red }}
          color={""}
        />
      )}
    </ET3Div>
  );
});

export default SelectAllContainer;
